import { createIcon } from '@chakra-ui/react';

export const SaveIcon = createIcon({
	viewBox: '0 0 24 24',
	d: 'M5 21h14c1.103 0 2-.897 2-2V8a.9974.9974 0 0 0-.293-.707l-4-4A.9961.9961 0 0 0 16 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2Zm10-2H9v-5h6v5ZM13 7h-2V5h2v2ZM5 5h2v4h8V5h.586L19 8.414 19.001 19H17v-5c0-1.103-.897-2-2-2H9c-1.103 0-2 .897-2 2v5H5V5Z',
});
